import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { T2TemplateBasicComponent } from 'app/trip2-theme/components/t2-template-basic/t2-template-basic.component';

const routes: Routes = [
  { path: 'pages', component: T2TemplateBasicComponent,
    children: [
      { path: 'debuger-app',
        children: [
          // { path: 'view-log', component: ViewLogComponent, data: { title: 'View Log'} },
          // { path: 'supports', component: SupportViewComponent, data: { title: 'View Supports' } }
        ]
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class DebugerAppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/debuger-app/debuger-app-routing.module.ts